'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhone = exports.formatAddress = exports.formatDateToBR = exports.formatDateToUS = exports.formatCNPJ = exports.formatCPF = exports.formatToUSOnlyDecimal = exports.formatToUS = exports.formatToBRL = exports.onlyNumber = undefined;
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
var _numeral = require('numeral');
var _numeral2 = _interopRequireDefault(_numeral);
require('numeral/locales');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var onlyNumber = exports.onlyNumber = function onlyNumber(text) {
  if (text === undefined) {
    return undefined;
  }
  return text.replace(/\D+/g, '');
};
var formatToBRL = exports.formatToBRL = function formatToBRL(amount) {
  _numeral2.default.locale('pt-br');
  return (0, _numeral2.default)(amount).format('0.0,');
};
var formatToUS = exports.formatToUS = function formatToUS(amount) {
  return (0, _numeral2.default)(amount).format('0,0');
};
var formatToUSOnlyDecimal = exports.formatToUSOnlyDecimal = function formatToUSOnlyDecimal(amount) {
  return amount.replace(/,/g, 'brl').replace(/\./, '').replace(/brl/g, '.');
};
var formatCPF = exports.formatCPF = function formatCPF(cpf) {
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};
var formatCNPJ = exports.formatCNPJ = function formatCNPJ(cnpj) {
  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
};
var formatDateToUS = exports.formatDateToUS = function formatDateToUS(dateBR) {
  if (dateBR !== undefined && dateBR !== null && dateBR.trim() !== "") {
    var date = dateBR.split('/');
    return (date[2] + "-" + date[1] + "-" + date[0]).replace(/\_/g, '');
  }
  return "";
};
var formatDateToBR = exports.formatDateToBR = function formatDateToBR(value) {
  var tempVal = value !== undefined && value !== null ? value.replace(/\_/g, '') : value;
  if (tempVal !== undefined && tempVal !== null && tempVal.length >= 10) {
    return (0, _moment2.default)(value).format('DD/MM/YYYY');
  }
  return value;
};
var formatAddress = exports.formatAddress = function formatAddress(addressObj) {
  var logradouro = addressObj.logradouro,
    numero = addressObj.numero,
    complemento = addressObj.complemento,
    uf = addressObj.uf,
    cep = addressObj.cep,
    bairro = addressObj.bairro,
    cidade = addressObj.cidade;
  var address = "";
  if (logradouro !== undefined && logradouro !== null && logradouro !== "") address += logradouro;
  if (numero !== undefined && numero !== null && numero !== "") address += ', ' + numero;
  if (complemento !== undefined && complemento !== null && complemento !== "") address += ' ' + complemento;
  if (bairro !== undefined && bairro !== null && bairro !== "") address += ' ' + bairro;
  if (cidade !== undefined && cidade !== null && cidade !== "") address += ' - ' + cidade;
  if (uf !== undefined && uf !== null && uf !== "") address += ' - ' + uf;
  if (cep !== undefined && cep !== null && cep !== "") address += ' - CEP: ' + cep;
  return address;
};
var formatPhone = exports.formatPhone = function formatPhone(phone) {
  if (phone !== undefined && phone !== null) {
    if (typeof phone === "string") {
      if (phone.length === 10) return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
      if (phone.length === 11) return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
  }
  return phone;
};